import * as $ from "jquery";

export function setupRegistration() {
    $("#referopen").on("click", function () {
        $("#referfields").show("slow");
        $("#referopen").hide();
    });
}
